import { render, staticRenderFns } from "./golf.vue?vue&type=template&id=477dddc9&"
import script from "./golf.vue?vue&type=script&lang=js&"
export * from "./golf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports